import React, { Component } from 'react';
import querystring from 'query-string';
import MyLuckyDraws from './components/luck-draw';
import Rules from './components/rules';
import PriceRecord from './components/price-record';
import InviteFriends from './components/invite-friends';
import InviteCode from './components/invite-code';
import { AppList, getArray2Name, sensorsMonitor, getWhiteTime, changeIco } from '@/utils/utils';
import PrizeMsg from './map'
import '@/assets/css/luck-draw.scss';

const SaSdk = sensorsMonitor();
class LuckyDraws extends Component {
  constructor(props) {
    super(props);
    this.RecordRef = React.createRef()

    const query = querystring.parse(window.location.search);
    const app = query['app'] || 'kashway';
    let appRules = getArray2Name(AppList, app);
    if (!appRules) appRules = AppList[4];

    this.state = {
      app,
      appRules,
      awardCount: 0, // 剩余抽奖次数
      loading: false, // 等待客户端返回相应token过来才能请求接口
      appData: null, // 客户端信息
      inviteCode: '', // 邀请码
      inviteText: '', // 后端邀请文案
      activityDate: '', // 活动时间
    }
  }

  // 获取app的请求头
  getAppData() {
    if (window.android) {
      const json = window.android.getRequestHeaders();

      const data = json ? JSON.parse(json) : null;
      this.setState({
        appData: Object.assign({}, this.state.appData, data),
        loading: true,
      })
    } else {
      this.setState({
        appData: Object.assign({}, this.state.appData, {
          Authorization: 'Bearer 629E949ABE6B2A3FB6F06391473C042B89CAC48CF5AF4A16725FA0A912C6B69F', // 尼日利亚
        }),
        loading: true,
      })
    }
  }

  // 数据打点相关
  sensorsInit() {
    SaSdk.registerPage({
      current_url: window.location.href,
      pagename: 'h5_lucky_draws',
      appName: this.state.appRules.appName,
    })

    SaSdk.quick('autoTrack');
    SaSdk.track('h5_lucky_draws_pageview', {
      load_time: getWhiteTime()
    });
  }

  componentDidMount(){
    const query = querystring.parse(window.location.search);
    const app = query['app'] || 'kashway';
    
    document.title = ( PrizeMsg[app] && PrizeMsg[app].title ) || PrizeMsg['default'].title // 界面标题

    this.getAppData();
    this.sensorsInit();
    changeIco(this.state.app);
  }

  setAwardCount(count, date) {
    this.setState({
      awardCount: count,
      activityDate: date
    });

    // 重新获取获奖列表
    this.RecordRef.current.getList();
  }

  setIvCode (v) {
    const { inviteCode, inviteText } = v;
    this.setState({
      inviteCode,
      inviteText,
    });
  }

  render() {
    const { awardCount, app, appRules, appData, loading, inviteCode, inviteText, activityDate } = this.state;

    const mainClass = 'lucky-draws ' + app;
    const layoutClass = 'container ' + app;
    const isLuck = ['xfectivo','ipeso','xcredit','imoney','ipesa','kashway'].includes(app) // 决定用什么头部
    const mainLuck = ( isLuck && <div className="head-bg-luck"></div> ) || null // 圣诞节活动的头部
    const noMainLuck = isLuck ? null : <div className="head-bg"></div> // 普通活动的头部
    const invitePosition = ['ipeso','xfectivo'].includes(app)
    // console.log(invitePosition)
    return <div className={ layoutClass } style={{display:'flex',flexDirection:'column'}}>
        <div className="main-inner">
          { mainLuck }
          <div className={ mainClass }>
            { noMainLuck }
            {/* 抽奖区域 */}
            <div className="draws-areas">
              <h2 className="draws-areas-title">
                { ( PrizeMsg[app] && PrizeMsg[app].drawsTitle ) || PrizeMsg['default'].drawsTitle }
                <b>{ awardCount }</b>
              </h2>
              {
                loading ? 
                <MyLuckyDraws
                  app={ app }
                  appRules={ appRules }
                  onAwardCount={(count, date) => this.setAwardCount(count, date) }
                  appData={ appData }
                  SaSdk={ SaSdk }
                /> : ''
              }
            </div>
          {
            loading ?
            invitePosition ? <PriceRecord
                ref={this.RecordRef}
                app={ app }
                appData={ appData }
                appRules={ appRules }
              /> 
              :
              <InviteCode
                app={ app }
                appData={ appData }
                appRules={ appRules }
                onChange={(val) => this.setIvCode(val) }
              /> 
            :''
          }

          {
            loading ?
            invitePosition ? <InviteCode
                app={ app }
                appData={ appData }
                appRules={ appRules }
                onChange={(val) => this.setIvCode(val) }
              /> 
              :
              <PriceRecord
                ref={this.RecordRef}
                app={ app }
                appData={ appData }
                appRules={ appRules }
              /> 
            :''
          }

          {/* 获取抽奖次数规则 */}
          <Rules
            app={ app }
            activityDate={ activityDate }
            appRules={ appRules }
          />
        </div>
      </div>
      
      { loading ? <InviteFriends
          app={ app }
          appData={ appData }
          appRules={ appRules }
          inviteCode={ inviteCode }
          inviteText={ inviteText }
        /> : '' }
    </div>
  }
}

export default LuckyDraws;
